var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.06 0H5.093C3.452 0 2.094 1.219 1.98 2.79L0 30h12.968c1.64 0 2.999-1.22 3.113-2.79L18.06 0Z",
    fill: "#98DAF8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26 0H13.032c-1.64 0-2.999 1.219-3.113 2.79L8.496 22.368h12.968c1.64 0 2.999-1.219 3.113-2.79L26 0Z",
    fill: "#8588C1",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.919 2.79C10.033 1.22 11.393 0 13.03 0H5.092C3.452 0 2.094 1.219 1.98 2.79L0 30h12.968c1.64 0 2.999-1.22 3.113-2.79l.351-4.842H8.494L9.919 2.79Z",
    fill: "#02EFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m18.062 0-1.627 22.368h5.03c1.64 0 2.998-1.219 3.112-2.79L26.001 0h-7.94Z",
    fill: "#5E2BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.032 0c-1.638 0-2.999 1.219-3.113 2.79L8.496 22.368h7.939L18.06 0h-5.03Z",
    fill: "url(#logo_svg__a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.06 0H5.093C3.452 0 2.094 1.219 1.98 2.79L0 30h12.968c1.64 0 2.999-1.22 3.113-2.79L18.06 0Z",
    fill: "#02EFF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H13.032c-1.64 0-2.999 1.219-3.113 2.79L8.496 22.368h12.968c1.64 0 2.999-1.219 3.113-2.79L26 0Z",
    fill: "#5E2BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.919 2.79C10.033 1.22 11.393 0 13.03 0H5.092C3.452 0 2.094 1.219 1.98 2.79L0 30h12.968c1.64 0 2.999-1.22 3.113-2.79l.351-4.842H8.494L9.919 2.79Z",
    fill: "#02EFF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m18.062 0-1.627 22.368h5.03c1.64 0 2.998-1.219 3.112-2.79L26.001 0h-7.94Z",
    fill: "#5E2BFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.032 0c-1.638 0-2.999 1.219-3.113 2.79L8.496 22.368h7.939L18.06 0h-5.03Z",
    fill: "url(#logo_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x1: 19.105,
    y1: 20.886,
    x2: 8.615,
    y2: 1.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02EFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__b",
    x1: 19.105,
    y1: 20.886,
    x2: 8.615,
    y2: 1.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02EFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2BFF"
  })))));
};
export default SvgLogo;